const falsyNot0 = (val) => !val && val !== 0;

export default falsyNot0;
